/* HOME PASSION · urun kartinda hizli ekle (+)

   DUZELTME — 422 YANITI YUTULUYORDU
   ---------------------------------
   Eski surum yalnizca r.json() okuyor, r.ok'i HIC kontrol etmiyordu.
   Stok yetmediginde Shopify 422 donuyor ve urunu EKLEMIYOR; buton yine de
   yesil tik gosterip "eklendi" diyordu ve acilir sepet aciliyordu.
   Artik r.ok kontrol ediliyor: hata varsa Shopify'in kendi mesaji
   (description / message) kartin altinda gosteriliyor, sahte basari
   gosterilmiyor ve sepet acilmiyor.
   Dogru davranisin referansi: sections/hp-product.liquid > [data-atc]. */
(function(){
  'use strict';

  function ensureStyle(){
    if(document.getElementById('hp-qa-style')) return;
    var st=document.createElement('style');
    st.id='hp-qa-style';
    st.textContent='.hp-qa-err{margin:6px 0 0;font-size:.78rem;line-height:1.4;color:#B3261E}';
    document.head.appendChild(st);
  }

  function showErr(btn, msg){
    ensureStyle();
    var host = btn.closest('.hp-pc, .hp-product-card, article, li, div') || btn.parentNode;
    var old = host.querySelector(':scope > .hp-qa-err');
    if(old) old.remove();
    var el=document.createElement('div');
    el.className='hp-qa-err';
    el.setAttribute('role','status');
    el.textContent = msg || 'Bu ürün şu an eklenemedi.';
    host.appendChild(el);
    setTimeout(function(){ if(el.parentNode) el.remove(); }, 6000);
  }

  function init(root){
    (root||document).querySelectorAll('.hp-pc-add:not([data-qa])').forEach(function(b){
      b.dataset.qa='1';
      b.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        if(b.dataset.busy) return; b.dataset.busy='1';
        var id=parseInt(b.dataset.vid,10);
        if(!id){ b.dataset.busy=''; return; }
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:id,quantity:1}]})})
          .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, data:j}; }); })
          .then(function(res){
            if(!res.ok){
              /* Shopify 422: stok yetmedi ya da varyant satin alinamiyor.
                 Hicbir sey eklenmedi — basari gosterme, sepeti acma. */
              showErr(b, res.data && (res.data.description || res.data.message));
              b.dataset.busy='';
              return;
            }
            b.classList.add('done');
            b.innerHTML='<svg viewBox="0 0 24 24"><path d="M5 12l5 5L19 7"/></svg>';
            document.dispatchEvent(new CustomEvent('hp:cart-added'));
            setTimeout(function(){
              b.classList.remove('done');
              b.innerHTML='<svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>';
              b.dataset.busy='';
            },1600);
          })
          .catch(function(){ showErr(b, 'Bağlantı hatası, tekrar deneyin.'); b.dataset.busy=''; });
      });
    });
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){init()}); }
  else { init(); }
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();
